import { Injectable } from '@angular/core';
import { PUBLIC_ROUTES } from 'pi-api';
import { environment } from '@env';
import { ElectronService } from '../platform/electron.service';

/**
 * Reguły doklejania tokenu.
 *
 * `disallowedRoutes` budujemy z listy tras publicznych w `pi-api`. Wcześniej w plikach
 * środowisk siedziały regexy z członem `api/`, którego nasze adresy nie zawierają —
 * więc nie wykluczały niczego i token leciał także do logowania.
 */
@Injectable()
export class jwtOptionsFactory {
  public skipWhenExpired = false;
  public throwNoTokenError = false;
  public allowedDomains: RegExp[] | string[] = environment?.jwt?.allowedDomains ?? [];
  public disallowedRoutes: RegExp[] | string[] = [
    ...PUBLIC_ROUTES.map((route) => new RegExp(route.replace(/\//g, '\\/'), 'i')),
    /assets/,
  ];

  public tokenGetter = () => {
    return ElectronService.getToken();
  };
}
